import Swal from 'sweetalert2';

const showAlert = (
  text,
  preConfirm,
  confirmButtonText,
  icon = 'warning',
  confirmBtnColor = '#d30b0b',
  cancelBtnColor = '#757f91',
  cancelButtonText = 'Cancel',
) => {
  return Swal.fire({
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText,
    cancelButtonText,
    showLoaderOnConfirm: true,
    preConfirm,
    allowOutsideClick: () => !Swal.isLoading(),
  });
};

export const showAlertHtml = (
  html,
  preConfirm,
  confirmButtonText,
  icon = 'warning',
  confirmBtnColor = '#d30b0b',
  cancelBtnColor = '#757f91',
) => {
  Swal.fire({
    html,
    icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText,
    showLoaderOnConfirm: true,
    preConfirm,
    allowOutsideClick: () => !Swal.isLoading(),
  });
};

export const showNotice = (html, title = 'Please note!', icon = 'warning') => {
  Swal.fire({ title, html, icon });
};

export const showAlertHtmlWithFeedback = async (
  html,
  preConfirm,
  confirmButtonText,
  feedbackData,
  title = 'Are you sure?',
  icon = 'warning',
  confirmBtnColor = '#d30b0b',
  cancelBtnColor = '#757f91',
) => {
  const confirmation = await Swal.fire({
    title,
    html,
    icon,
    showCancelButton: true,
    confirmButtonColor: confirmBtnColor,
    cancelButtonColor: cancelBtnColor,
    confirmButtonText,
    allowOutsideClick: () => !Swal.isLoading(),
  });

  if (confirmation.isConfirmed) {
    preConfirm();
    if (feedbackData && Object.keys(feedbackData).length) {
      const { feedbackTitle, feedbackIcon, feedbackHtml } = feedbackData || '';
      Swal.fire({ title: feedbackTitle, html: feedbackHtml, icon: feedbackIcon });
    }
  }
};

export default showAlert;
